import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Batch aggregate of Bud Link *native* shop reviews (community sentiment).
 * Returns `{ [slug]: { rating, rating_count } }`. Empty object while
 * loading or on error — the caller renders nothing for shops without data.
 */
export function useNativeShopRatings(slugs) {
  const [ratings, setRatings] = useState({});

  useEffect(() => {
    if (!slugs || !slugs.length) {
      setRatings({});
      return;
    }
    const key = slugs.slice().sort().join(",");
    let cancelled = false;
    api
      .get(`/dispensaries/reviews/batch?slugs=${encodeURIComponent(key)}`)
      .then((r) => {
        if (!cancelled) setRatings(r.data?.ratings || {});
      })
      .catch(() => {
        if (!cancelled) setRatings({});
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slugs?.length, (slugs || []).slice().sort().join(",")]);

  return ratings;
}
